import { ThemeProvider } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ErrorBoundary, GlobalErrorFallback } from '@/components/ui/ErrorBoundary';
import { ToastProvider } from '@/components/ui/ToastProvider';
import { AuthProvider } from '@/features/auth';
import { authClient } from '@/lib/auth-client';
import { queryClient } from '@/lib/query-client';
import { adsTheme } from '@/lib/theme';
import { router } from './router';

function App() {
  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <GlobalErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={adsTheme}>
          <AuthProvider client={authClient}>
            <RouterProvider router={router} />
            <ToastProvider />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export { App };
